// MyPortfolioController
app.controller('portfolioController', ['$scope', '$location', '$timeout', 'WdHttpService',
    'sessionService', 'config', 'analyticsService', '$ocLazyLoad',
    function ($scope, $location, $timeout,
        WdHttpService, sessionService, config, analyticsService, $ocLazyLoad) {

        $ocLazyLoad.load(['https://www.gstatic.com/charts/loader.js']);
        const marketOpens = 9 * 60 + 15;
        const marketClosed = 15 * 60 + 30;

        // Init 
        $scope.init = async function () {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            await $scope.failedEnachPaymentChecker();

            $scope.showGraphButton = true;
            $scope.showGraphSelectBox = false;
            $scope.subcribedUser = false;
            $scope.nonSubcribedUser = true;
            $scope.userwithFunds = true;
            $scope.userwithZeroFunds = false;
            $scope.userFundModeChange = true;
            $scope.withdrawAmount = true;
            $scope.withdrawSuccess = false;
            $scope.exitSummary = true;
            $scope.portfolioData = [];
            $scope.userFundPerformances = [];
            $scope.fund_details = undefined;
            $scope.sipList = [];
            $scope.totalPendingTradeConfirmations = 0;
            $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
            $scope.getMyPortfolio();
            $scope.refreshPerformance();
            $('#my-portfolio').addClass('active');
            $scope.hidePageLoader();
            // Buy Fund
            $scope.buyMoreFund = true;

            // set radio button active
            $scope.radio_investment_type = "LUMPSUM";

            document.addEventListener("wheel", function (event) {
                if (document.activeElement.type === "number" &&
                    document.activeElement.classList.contains("noscroll")) {
                    document.activeElement.blur();
                }
            });

            checkForPendingApprovalsAndRejections($scope);
            await $scope.agreementSigningforPendingUsers();
        }

        $scope.redirectToPendingActions = async function () {
            await $('#resolve_pending_rejected_orders_modal').modal('hide');
            $('.modal-backdrop').remove();
            $location.path('/fund-revision');
        }

        $scope.redirectToPendingApprovals = function () {
            $location.path('/fund-revision');
        }

        $scope.getMyPortfolio = function () {

            var data = { investingMode: $scope.investingMode };

            $scope.showPageLoader();
            WdHttpService._my_portfolio(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        try {
                            var userdata = response.data;

                            if (Object.keys(userdata).length === 0) {
                                $scope.nonSubcribedUser = true;
                                $scope.subcribedUser = false;
                            } else {
                                var userFunds = response.data.userFundPerformances;
                                if (Object.keys(userFunds).length === 0) {
                                    $scope.userwithFunds = false;
                                    $scope.userwithZeroFunds = true;
                                }
                                $scope.nonSubcribedUser = false;
                                $scope.subcribedUser = true;
                                $scope.portfolioData = response.data;
                                $scope.userFundPerformances = response.data.userFundPerformances;
                                $scope.lastPerformanceTime = response.data.timestamp;
                                $scope.totalPendingTradeConfirmations = 0;
                                $scope.pendingTradeConfirmationsFunds = [];

                                $scope.userFundPerformances.forEach(userFund => {
                                    if (userFund.status.pendingTradeConfirmations > 0) {
                                        $scope.pendingTradeConfirmationsFunds.push(userFund.displayName);
                                        $scope.totalPendingTradeConfirmations += userFund.status.pendingTradeConfirmations;
                                    }
                                });

                                google.charts.load('current', { 'packages': ['corechart'] });
                                google.charts.setOnLoadCallback(drawChart);
                            }
                            await $scope.allPendingActions();
                            $scope.$evalAsync();
                        } catch (error) {
                            console.log(error);
                            $scope.showErrorPopup(error);
                        }
                    }
                    $scope.hidePageLoader();
                }).catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup(error);
                });
        }

        $scope.subscibeFunds = function () {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            $location.path("fund-discovery");
        }

        $scope.period = 'INCEPTION';
        $scope.benchmark = "Nifty 50"
        $scope.gotoPageIn = function (invest) {
            $timeout(function () {
                $location.path('/user-fund/' + invest.adviserUsername + '/' + invest.fundName);
            }, 100);
        }

        $scope.refreshPerformance = function () {
            angular.element(document.querySelector(".dw-refresh-data")).addClass("loading");
            var data = {
                investingMode: $scope.investingMode
            };
            $scope.showPageLoader();
            WdHttpService._refresh_my_portfolio(data).then(function (response) {
                if (response.status == 200) {
                    angular.element(document.querySelector(".dw-refresh-data")).removeClass("loading");
                    $scope.portfolioData = [];
                    $scope.userFundPerformances = [];
                    $scope.getMyPortfolio();
                }
                $scope.hidePageLoader();
            }).catch(error => {
                $scope.hidePageLoader();
                $scope.showErrorPopup('Failed to update your performance as of now, we will retry again soon.');
                console.error(error);
            });
        }

        $scope.getFundDetails = async function () {
            var data = {
                q: "fundName:" + $scope.addMoreFundName,
                f: "web_admin:" + $scope.webadminName
            }
            $scope.showLoading("#buyMoreButton");
            await WdHttpService._get_funds(data)
                .then(function (response) {
                    if (response.status == 200 && response.data.Items.length > 0) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $routeParams.fundname)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];


                        $scope.fund_details = fund_details;

                        angular.forEach(fund_details.childFund, function (value, key) {
                            $scope.sipList.push({
                                "fundName": value.fundName,
                                "minSipAmount": value.minAmount
                            })
                        });

                        if ($scope.investmentType == 'SIP') {
                            $scope.investmentSipAmt = $scope.fund_details.childFund[0].minAmount;
                            for (var i = 0; i < $scope.fund_details.childFund.length; i++) {
                                if ($scope.fund_details.childFund[i].minAmount <= $scope.investmentSipAmt) {
                                    $scope.investmentSipAmt = $scope.fund_details.childFund[i].minAmount;
                                }
                            }
                            $scope.investmentAmt = parseInt($scope.investmentSipAmt);
                            $scope.investmentAmtOriginally = parseInt($scope.investmentSipAmt);
                        } else {
                            if (fund_details.minAdditionalLumpsum) {
                                $scope.investmentAmtOriginally = parseInt(fund_details.minAdditionalLumpsum);
                                $scope.investmentAmt = parseInt(fund_details.minAdditionalLumpsum);
                            } else {
                                $scope.investmentAmtOriginally = parseInt(fund_details.minAmount);
                                $scope.investmentAmt = parseInt(fund_details.minAmount);
                            }
                        }
                    } else {
                        $scope.showErrorPopup('Portfolio details not found (' + $scope.addMoreFundName + ')');
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorPopup('Could not fetch portfolio details (' + $scope.addMoreFundName + ') due to error.');
                });

            $scope.stopLoading("#buyMoreButton");
        }

        $scope.withdrawModalOpen = async function (invest) {
            $scope.withdrawFundValue = invest.currentValue;
            $scope.withdrawFundName = invest.fundName;
            $scope.withdrawDisplayName = invest.displayName;
            $scope.withdrawFundAdviserUsername = invest.adviserUsername;
            $scope.withdrawInvestmentType = invest.investmentType;
            $scope.withdrawAmount = true;
            $scope.withdrawSummery = false;
            $scope.confirmWithdrawError = false;
            $scope.withdrawError = false;
            $('#dw_withdraw_amount').val('');
            $scope.withdraw_amount = '';
            $('#withdrawPartiallyModal').modal('show');
            var eventData = {
                'fundName': invest.fundName.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer('withdraw-modal-opened', eventData);
        }

        $scope.confirmWithdrawal = function () {

            $scope.submitted = true;

            if ($scope.withdrawFundForm.$valid && $scope.withdraw_amount > 0) {
                $scope.showPageLoader();
                $('#confirm_withdrawal_modal').modal('hide');
                $('#withdrawPartiallyModal').modal('hide');
                $scope.stopLoading("#partialWithdrawConfirmButton");

                $scope.redirectToOrderExecution($scope.withdrawInvestmentType, $scope.withdraw_amount, $scope.withdrawFundName, 'PARTIALWITHDRAWAL');
            } else {
                onWithdrawError($scope, "Please enter correct withdraw amount");
            }
        }

        $scope.submitWithdrawFundForm = async function () {
            $scope.submitted = true;

            if ($scope.withdrawFundForm.$valid) {
                $scope.widthDrawAmount = $scope.withdraw_amount;
                await analyticsService._push_custom_event_data_to_datalayer('withdraw-confirm-modal-opened', {});

                $scope.withdrawError = false;
                $scope.withdrawAmount = false;
                $scope.withdrawSummery = true;
            } else {
                return false;
            }
        }

        $scope.reInitiateWithdrawal = function () {
            $scope.withdrawSummery = false;
            $scope.withdrawAmount = true;
        }

        $scope.cancelWithdrawal = function () {
            //TODO: reset all variables
            angular.element(document.querySelector(".lds-ellipsis")).removeClass("dw-inline-block");
            angular.element(document.querySelector(".dw-sign-btn")).removeClass("dw-none");
            $scope.withdrawSummery = false;
            $('#withdrawPartiallyModal').modal('hide');
        }

        $scope.exitModalOpen = async function (invest) {
            $scope.showPageLoader();
            $scope.exitFundName = invest.fundName;
            var eventData = {
                'fundName': invest.fundName.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer('clicked-exit', eventData);
            $scope.redirectToOrderExecution(invest.investmentType, 0, invest.fundName, 'UNSUBSCRIPTION');
        }

        $scope.cancelExit = function () {
            $scope.exitSummary = false;
            $('#exitModal').modal('hide');
        }


        $scope.addMoreModalOpen = async function (invest) {
            $scope.addMoreStockConfirmationGetDetails = [];
            $scope.addMoreFundValue = invest.currentValue;
            $scope.addMoreFundName = invest.fundName;
            $scope.investmentType = invest.investmentType;
            $scope.addMoreDisplayName = invest.displayName;
            $scope.addMoreFundMode = invest.investingMode;
            $scope.addMoreAdviserUsername = invest.adviserUsername;
            $scope.buyMoreError = false;
            $scope.buyMoreConfirmError = false;
            $scope.buyMoreFund = true;
            $scope.congratsData = false;
            $scope.withdraw_amount = '';
            await $scope.getFundDetails();
            if ($scope.investmentAmtOriginally) {
                $('#byFundModal').modal('show');
                var eventData = {
                    'fundName': invest.fundName.toLowerCase()
                };
                await analyticsService._push_custom_event_data_to_datalayer('buy-more-modal-opened', eventData);

            } else {
                $scope.showProcessingPopup('Kindly be in good network connectivity, as you might expect delays due to low connectivity.');
            }
        }

        $scope.addMoreStockConfirmationGetDetails = [];
        $scope.addMoreSubmit = function (addMoreFundName) {
            $scope.submitted = true;
            const investingAmount = $("#totalInvAmount").val().replace(/,/g, '');
            if (parseFloat(investingAmount) < $scope.investmentAmtOriginally) {
                $scope.showErrorMessageInSubscribeForm('Amount must be more than Minimum Investment Amount shown above');
                return;
            } else if (investingAmount == 'NaN') {
                $scope.showErrorMessageInSubscribeForm('Amount must be a number.');
                return;
            } else if ($scope.buyMoreFundForm.$valid) {
                $('#byFundModal').modal('hide');
                $scope.redirectToOrderExecution('LUMPSUM', investingAmount, addMoreFundName, 'ADDITIONALSUBSCRIPTION');
            }
        }

        $scope.redirectToOrderExecution = function (investmentType, investingAmount, fundName, purpose) {
            $scope.showPageLoader();
            var data = {
                purpose: purpose,
                investingMode: $scope.investingMode,
                investmentAmount: investingAmount,
                investmentType: investmentType,
                fundName: fundName,
                adviserUsername: $scope.getAdviserUsernameFromFundName(fundName),
                sipDay: 0
            }


            WdHttpService._is_fee_paid(data)
                .then(async response => {
                    var eventData = {
                        'fundName': fundName.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('fund-action-fee-paid-' + purpose, eventData);
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                }).catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup(error);
                });
        }
        $scope.addMoreExit = function () {
            $('#byFundModal').modal('hide');
            $scope.addMoreStockConfirmationGetDetails = [];
        }

        $scope.showErrorMessageInSubscribeForm = function (message) {
            $scope.subStatus = true;
            $scope.subcritionErrorMsg = message;
            $timeout(function () {
                $scope.subStatus = false;
            }, 5000);
        }

        function onWithdrawError($scope, error) {
            $scope.confirmWithdrawError = true;
            if (typeof error == 'string')
                $scope.confirmWithdrawErrorMsg = error;
            else
                $scope.confirmWithdrawErrorMsg = 'Error while communicating with server.';
            $timeout(function () {
                $scope.confirmWithdrawError = false;
            }, 5000);
        }

        $scope.closeReminder = function () {
            sessionService.set('stopApprovalReminder', 'true');
            $('#resolve_pending_rejected_orders_modal').modal('hide');
        }

        $scope.getAdviserUsernameFromFundName = function (fundName) {
            for (let index = 0; index < $scope.userFundPerformances.length; index++) {
                const fund = $scope.userFundPerformances[index];
                if (fund.fundName == fundName) {
                    return fund.adviserUsername;
                }
            }
        }

        $scope.statusPerWB = {}
        $scope.allPendingActions = async function () {
            const noStatus = {
                label: "UpTo Date",
                class: "dw-confirmed"
            }
            await WdHttpService._get_all_pending_actions(true)
                .then(response => {
                    $scope.pendingActions = response.data.pendingOrderIds;
                    for (let index = 0; index < $scope.userFundPerformances.length; index++) {
                        const userWealthBasket = $scope.userFundPerformances[index];
                        let hasBoth = false;
                        if ($scope.pendingActions.filter(wbStatus => wbStatus.fundName == userWealthBasket.fundName).length > 1) {
                            hasBoth = $scope.pendingActions.filter(wbStatus => wbStatus.fundName == userWealthBasket.fundName)
                                .every(status => status.purpose == 'REJECTEDREBALANCEAPPROVALS' || status.purpose == 'PENDINGREBALANCEAPPROVALS')
                        }

                        let status = $scope.pendingActions.find(wbStatus => wbStatus.fundName == userWealthBasket.fundName);
                        if (status) {
                            if (hasBoth) {
                                $scope.statusPerWB[userWealthBasket.fundName] = {
                                    label: "Pending & Rejected",
                                    class: "dw-pending-rejected"
                                }
                            } else if (status.purpose == 'REJECTEDREBALANCEAPPROVALS') {
                                $scope.statusPerWB[userWealthBasket.fundName] = {
                                    label: "Rejected",
                                    class: "dw-rejected"
                                }
                            } else if (status.purpose == 'PENDINGREBALANCEAPPROVALS') {
                                $scope.statusPerWB[userWealthBasket.fundName] = {
                                    label: "Pending",
                                    class: "dw-pending"
                                }
                            } else {
                                $scope.statusPerWB[userWealthBasket.fundName] = noStatus
                            }
                        } else {
                            $scope.statusPerWB[userWealthBasket.fundName] = noStatus
                        }
                    }
                });
        }

        function checkForPendingApprovalsAndRejections($scope) {
            var now = new Date();
            const currentMinutes = now.getHours() * 60 + now.getMinutes();
            if ((currentMinutes > marketOpens) && (currentMinutes < marketClosed) && sessionService.get('stopApprovalReminder') != true) {
                if (sessionService.get('pendingOrdersAvailable')) {
                    $scope.rejectedOrdersFromPortfolio = false;
                    $('#resolve_pending_rejected_orders_modal').modal('show');
                } else if (sessionService.get('rejectedOrdersAvailable')) {
                    $scope.rejectedOrdersFromPortfolio = true;
                    $('#resolve_pending_rejected_orders_modal').modal('show');
                }
            }
        }

        function drawChart() {

            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Symbol');
            data.addColumn('number', 'Allocation');
            var portfolioData = $scope.userFundPerformances;
            angular.forEach(portfolioData, function (value, key) {
                data.addRows([
                    [value.displayName, value.totalInvestment]
                ]);
            });

            var options = {
                title: '',
                pieSliceText: 'none',
                colors: ['#516091', '#74bec1', '#adebbe', '#eef3ad', '#fad9ad', '#ffb6c1'],
                pieSliceBorderColor: 'transparent',
                legend: 'bottom',
                chartArea: { 'width': '100%', 'height': '80%', left: 0 },
                titleTextStyle: {
                    color: '#333',
                    fontSize: 12,
                },
                pieSliceTextStyle: {
                    color: '#333',
                    fontSize: 12,
                }
            };
            var element = document.getElementById('piechart');
            if (element != undefined) {
                var chart = new google.visualization.PieChart(document.getElementById('piechart'));
                chart.draw(data, options);
            }
        }
    }
]);